"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportButton = exports.CSS = void 0;
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var icons_1 = require("../icon/icons");
var index_2 = require("../icon/index");
var theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Import-Button',
    MDL: {
        container: 'mdl-button mdl-button--accent mdl-button--fab'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        position: 'fixed',
        bottom: '160px',
        right: '8%',
        'z-index': 5
    },
    _a));
exports.ImportButton = {
    view: function (ctx) {
        if (ctx === void 0) { ctx = {}; }
        return (0, mithril_1.m)('button', {
            className: "".concat(exports.CSS.container, " ").concat(exports.CSS.MDL.container),
            disabled: ctx.disabled,
            title: (0, index_1.Translate)(ctx.title),
            onclick: ctx.onclick
        }, index_2.Icon.view(icons_1.MaterialIcon.FILE_UPLOAD));
    }
};
//# sourceMappingURL=import.button.js.map